import "../../App.css";
import React, { lazy, Suspense, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import Loading from "../../Component/Loading";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import {
  InfluencerEmpPanelSidebarData,
  InfluencerPanelSidebarData,
} from "../../Module/influencerPanelSidebarData";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar } from "../../Action/snackbarAction";
import { Logout, setInitialState } from "../../Action/authAction";

const Dashboard = lazy(() => import("./dashboard"));
const RevenueAnalysis = lazy(() => import("./revenueAnalysis"));
const TotalRevenue = lazy(() => import("./totalRevenue"));
// const LeadOrder = lazy(() => import("./leadOrder"));
const InfluencerRank = lazy(() => import("./influencerRank"));
const InfluencerPayment = lazy(() => import("./influencerPayment"));
const MovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting")
);
const EditMovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting")
);
const Guidelines = lazy(() => import("./guidelines"));
const Agreement = lazy(() => import("./agreement"));

const InfluencerDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (!(role === "INFLUENCER" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);

  return (
    <div className="AppBox">
      <Sidebar
        data={
          loginType === 2
            ? InfluencerEmpPanelSidebarData
            : InfluencerPanelSidebarData
        }
      />
      <div className="dashboard">
        {
          <Suspense
            fallback={
              <div className="border p-1">
                <Loading />
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="revenueAnalysis" element={<RevenueAnalysis />} />
              <Route path="totalRevenue" element={<TotalRevenue />} />
              {/* <Route path="leadOrder" element={<LeadOrder />} /> */}
              <Route path="influencerRank" element={<InfluencerRank />} />
              <Route path="influencerPayment" element={<InfluencerPayment />} />
              <Route
                path="movementsOfMeeting"
                element={<MovementsOfMeeting />}
              />
              <Route
                path="editMovementsOfMeeting"
                element={<EditMovementsOfMeeting />}
              />
              <Route path="guidelines" element={<Guidelines />} />
              <Route path="agreement" element={<Agreement />} />
            </Routes>
          </Suspense>
        }
      </div>
    </div>
  );
};

export default InfluencerDashboard;
